export const PostCardSkeleton = () => (
  <div
    data-testid="post-card-skeleton"
    aria-busy="true"
    className="flex w-full flex-col gap-4 p-4"
  >
    <div className="flex items-center gap-3">
      <div className="size-10 shrink-0 animate-pulse rounded-full bg-[#E4E4E4]" />
      <div className="flex flex-col gap-2">
        <div className="h-4 w-32 animate-pulse rounded bg-[#E4E4E4]" />
        <div className="h-3 w-12 animate-pulse rounded bg-[#E4E4E4]" />
      </div>
    </div>
    <div className="h-4 w-3/4 animate-pulse rounded bg-[#E4E4E4]" />
    <div className="h-4 w-1/2 animate-pulse rounded bg-[#E4E4E4]" />
  </div>
);
